import {
  PricingOutOfDateIndicator as SharedPricingOutOfDateIndicator,
  PricingOutOfDateNotice as SharedPricingOutOfDateNotice,
} from "../ProposalPresentation/pricing/pricing-out-of-date"

export {
  OutOfDateNotice,
  PRICING_OUT_OF_DATE_LABEL,
  REFRESH_PRICING_BUSY_LABEL,
  REFRESH_PRICING_ERROR_PROMPT,
  REFRESH_PRICING_LABEL,
} from "../ProposalPresentation/pricing/pricing-out-of-date"

const BATTERY_PRICING_OUT_OF_DATE_TEST_ID = `battery-pricing-out-of-date`

export const PricingOutOfDateIndicator = (): JSX.Element => (
  <SharedPricingOutOfDateIndicator
    testId={BATTERY_PRICING_OUT_OF_DATE_TEST_ID}
  />
)

export const PricingOutOfDateNotice = (): JSX.Element => (
  <SharedPricingOutOfDateNotice testId={BATTERY_PRICING_OUT_OF_DATE_TEST_ID} />
)
